module.exports = __webpack_public_path__ + "static/qcized-9067317969bf049c0a63cff7e450e73a.jpg";